import React, { Fragment, useEffect, useRef, useState } from "react";
import close from "../../../assets/images/model/close.svg";
import UploadedVideo from "./UploadedVideo";

const VideoUploadComponent = ({
  setUploadVideo,
  onVideoUploaded,
  setUploadVideoShow,
  onSuccess,
}) => {
  const [uploadVideos, setUploadVideos] = useState(true);
  const [uploadLoadedVideo, setUploadLoadedVideo] = useState(false);
  const [videoFile, setVideoFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const circleRef = useRef();
  const [videoURL, setVideoURL] = useState("");
  const [error, setError] = useState("");

  const embedRegex = /^https:\/\/www\.youtube\.com\/embed\/\S*$/;
  const simpleRegex =
    /^https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})$/;
  const shortRegex = /^https:\/\/youtu\.be\/([a-zA-Z0-9_-]{11})/;
  const handleUpload = () => {
    let embedURL = videoURL.trim();

    if (embedRegex.test(embedURL)) {
      // URL is already in embed format
    } else if (simpleRegex.test(embedURL)) {
      // Convert regular YouTube URL to embed URL
      const match = embedURL.match(simpleRegex);
      const videoId = match[1];
      embedURL = `https://www.youtube.com/embed/${videoId}`;
    } else if (shortRegex.test(embedURL)) {
      // Convert short YouTube URL to embed URL
      const match = embedURL.match(shortRegex);
      const videoId = match[1];
      embedURL = `https://www.youtube.com/embed/${videoId}`;
    } else {
      alert("Please enter a valid YouTube URL.");
      return;
    }

    setVideoFile(embedURL);
    setUploadVideo(false);
    setUploadLoadedVideo(true);
    setUploadVideos(false);
    setIsLoading(false);
    onSuccess(embedURL, "", "");
  };
  useEffect(() => {
    const items = document.querySelectorAll(".progress-item");
    const newIntervals = Array.from(items).map((_, index) => {
      return setInterval(() => {
        const updatedPercentage = (uploadProgress / 100) * 100;
        items[
          index
        ].style.background = `conic-gradient(var(--Purple-700, #6700B2) calc(${updatedPercentage}%),var(--Purple-300, #DDD5EB) 0deg)`;
        items[index].setAttribute("data-value", `${updatedPercentage}%`);
        items[index].textContent = `${updatedPercentage}%`;

        if (uploadProgress === 100) {
          clearInterval(newIntervals[index]);
        }
      }, 15);
    });

    return () => {
      newIntervals.forEach((interval) => clearInterval(interval));
    };
  }, [uploadProgress]);

  const updateProgress = (progress) => {
    if (circleRef.current) {
      const circle = circleRef.current.querySelector("b");
      const deg = (progress / 100) * 360;
      if (circle) {
        if (deg <= 180) {
          circle.style.setProperty("--rotate-before", `rotate(${deg}deg)`);
          circle.style.setProperty("--rotate-after", "rotate(0deg)");
        } else {
          circle.style.setProperty("--rotate-before", "rotate(180deg)");
          circle.style.setProperty("--rotate-after", `rotate(${deg - 180}deg)`);
        }
      }
    }
  };

  useEffect(() => {
    updateProgress(uploadProgress);
  }, [uploadProgress]);

  const handleClose = () => {
    setUploadVideo(false);
    setVideoURL("");
    setUploadVideoShow(false);
  };

  const handleDoneButtonClick = () => {
    if (videoURL && videoURL.trim() !== "" && videoFile) {
      if (onVideoUploaded) {
        onVideoUploaded(videoURL);
        setUploadVideoShow(false);
        setUploadVideo(false);
      }
    } else {
    }
  };

  const isS3Url = (url) => {
    return url.includes("s3.amazonaws.com");
  };

  const isYouTubeUrl = (url) => {
    return url.includes("youtube.com") || url.includes("youtu.be");
  };

  const isStreamableUrl = (url) => {
    return url.includes("streamable.com");
  };

  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={close} alt="close" onClick={handleClose} />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>Add Video</h4>
              {uploadVideos && !isLoading && (
                <Fragment>
                  <p>Upload a video from a URL link.</p>
                  {videoFile && !error ? (
                    <iframe
                      width="640px"
                      height="385px"
                      style={{ borderRadius: "4px" }}
                      src={videoFile}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      onError={(e) => {
                        setError("Check your URL video can not be loaded");
                      }}
                    ></iframe>
                  ) : (
                    <div style={{ color: "red" }}>{error}</div>
                  )}
                  <form action="" className="upload_book">
                    <div className="input-link my-40 mb-24">
                      <div className="link-text">
                        <input
                          className="link-input"
                          placeholder="Paste the link..."
                          type="text"
                          value={videoURL}
                          onChange={(e) => {
                            setVideoURL(e.target.value);
                            let val = e.target.value;
                            if (embedRegex.test(val)) {
                              // URL is already in embed format
                            } else if (simpleRegex.test(val)) {
                              // Convert regular YouTube URL to embed URL
                              const match = val.match(simpleRegex);
                              const videoId = match[1];
                              val = `https://www.youtube.com/embed/${videoId}`;
                              setVideoFile(val);
                              setError("");
                            } else if (shortRegex.test(val)) {
                              // Convert short YouTube URL to embed URL
                              const match = val.match(shortRegex);
                              const videoId = match[1];
                              val = `https://www.youtube.com/embed/${videoId}`;
                              setVideoFile(val);
                              setError("");
                            } else {
                              setError("Invalid URL");
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="modal-btn">
                      <button
                        type="button"
                        className="btn-black_create"
                        onClick={handleUpload}
                      >
                        Upload from URL
                      </button>
                    </div>
                  </form>
                </Fragment>
              )}
              {isLoading && (
                <Fragment>
                  <form action="" className="upload_book">
                    <div className="upload_book_inner my-40 mb-0">
                      <div
                        className="drag_and_drop_box upload-boarder"
                        htmlFor="Drag-file"
                      >
                        <div className="upload_content">
                          <div className="icon mb-24"> </div>
                          <div className="deflat_content ">
                            <div id="progress">
                              <div
                                data-num={uploadProgress}
                                className="progress-item"
                              >
                                {uploadProgress.toFixed(2)}%
                              </div>
                            </div>
                            <h6 className="f-size-18 theme__primary__text">
                              Uploading video...
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}
              {uploadLoadedVideo && videoFile && (
                <Fragment>
                  <div className="video_iframe">
                    {isS3Url(videoURL) && (
                      <video
                        controls
                        style={{
                          width: "640px",
                          borderRadius: "4px",
                          height: "385px",
                        }}
                      >
                        <source src={videoURL} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}
                    {isYouTubeUrl(videoURL) && (
                      <iframe
                        width="640px"
                        height="385px"
                        style={{ borderRadius: "4px" }}
                        src={videoURL}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    )}
                    {isStreamableUrl(videoURL) && (
                      <iframe
                        width="640px"
                        height="385px"
                        style={{ borderRadius: "4px" }}
                        src={videoURL.replace("/s/", "/e/")}
                        title="Streamable video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    )}
                  </div>
                  <form action="" className="pick_from_library">
                    <div className="pick_from_library_filter_wrap">
                      <div className="pick_from_library_filter my-40 mt-20">
                        <div className="icon">
                          <div className="tooltip_wrap">
                            <h2 className="icon_h2">Video source</h2>
                          </div>
                          <input
                            style={{ height: "60px" }}
                            type="text"
                            value={videoURL}
                            className="pick_from_input_cre border_color url_bg"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-btn">
                      <button
                        type="button"
                        className="btn-black_create"
                        onClick={handleDoneButtonClick}
                      >
                        Done
                      </button>
                    </div>
                  </form>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoUploadComponent;
